export default "__VITE_ASSET__B7S$zqSP__"